import ShopCategoriesListModelBase from '../_generated/modelBases/shop-categories-list-model-base';

export default class ShopCategoriesListModel extends ShopCategoriesListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
